import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=6eb122e2&scoped=true&"
import script from "./GroupEdit.vue?vue&type=script&lang=js&"
export * from "./GroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupEdit.vue?vue&type=style&index=0&id=6eb122e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb122e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb122e2')) {
      api.createRecord('6eb122e2', component.options)
    } else {
      api.reload('6eb122e2', component.options)
    }
    module.hot.accept("./GroupEdit.vue?vue&type=template&id=6eb122e2&scoped=true&", function () {
      api.rerender('6eb122e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/GroupEdit.vue"
export default component.exports